<iris-icon
  class="pill-icon"
  [name]="icon"
  [size]="iconSmallSize"
  [usage]="iconDecorativeUsage"
  colorToken="$color-dec-kelly-100"
></iris-icon>
<span 
  class="pill-text" 
  [attr.data-test]="'pill-' + displayText"
>
  {{ displayText }}
</span>
